import styled from "@emotion/styled";

import { setFullViewportWidthStyles, theme } from "shared/lib/styles";

import { AdSlot } from "scmp-app/components/advertisement/ad-slots/ad-slot";

export const PageContainer = styled.div`
  ${setFullViewportWidthStyles}
`;

export const StyledAdSlot = styled(AdSlot)``;

export const AdsContainer = styled.div`
  ${theme.breakpoints.up("tablet")} {
    padding-block: 32px;
    padding-inline: 0;
  }

  ${theme.breakpoints.up("desktop")} {
    padding-block: 40px;
    padding-inline: 0;
  }

  ${StyledAdSlot} {
    background-color: #f6f6f6;
  }
`;
